module.exports = __webpack_public_path__ + "static/media/guide_desktop_05.19d6ef12.svg";